var _rect, _rect2, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgD9(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 56,
    viewBox: "0 0 40 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 56,
    rx: 5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 56,
    rx: 5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2837 13.668C24.2837 10.756 22.7497 9.09204 19.9417 9.09204C17.1337 9.09204 15.5997 10.756 15.5997 13.668V16.996C15.5997 19.674 16.6657 21.156 18.7717 21.156C20.0457 21.156 20.8777 20.61 21.3717 19.57H21.4237V22.872C21.4237 24.614 20.8517 25.108 19.8377 25.108C18.9277 25.108 18.3557 24.614 18.3557 23.314V22.664H15.6517V23.132C15.6517 26.044 17.1077 27.708 19.9157 27.708C22.8797 27.708 24.2837 26.044 24.2837 22.976V13.668ZM19.9417 18.556C19.0317 18.556 18.4597 18.062 18.4597 16.762V13.486C18.4597 12.186 19.0317 11.718 19.9417 11.718C20.8517 11.718 21.4237 12.186 21.4237 13.486V16.762C21.4237 18.062 20.8517 18.556 19.9417 18.556Z",
    fill: "#DC3059"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0566 33.1666L25.3333 40.4622L19.9433 47.8333L14.6666 40.5378L20.0566 33.1666Z",
    fill: "#DC3059"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgD9);
export default __webpack_public_path__ + "static/media/D9.24ea2c2d64b35da4cfdca97f30299526.svg";
export { ForwardRef as ReactComponent };